//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import action from './action';
export default {
  name: 'page',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    }
  },
  created() {
  },

  data() {
    return{
      pageTitle:"填写指引"
    }
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/guidelines/page.vue